/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Seg_CampusInputs */

const en_st_seg_campus = /** @type {(inputs: St_Seg_CampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A campus / capstone team`)
};

const id_st_seg_campus = /** @type {(inputs: St_Seg_CampusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim kampus / capstone`)
};

/**
* | output |
* | --- |
* | "A campus / capstone team" |
*
* @param {St_Seg_CampusInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_seg_campus = /** @type {((inputs?: St_Seg_CampusInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Seg_CampusInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_seg_campus(inputs)
	return en_st_seg_campus(inputs)
});